import { Link } from 'react-router-dom'

import { checkAuth } from 'utils/auth'
import withRouter from 'utils/withRouter'

const handleLogout = props => () => {
  localStorage.removeItem('token')
  props.navigate('/login')
}

const Nav = props => (
  <nav>
    <ul>
      <li><Link to='/'>Metis Analytics</Link></li>
    </ul>
    <ul>
      { checkAuth()
        ?
        <>
          <li><Link to='/settings'>Settings</Link></li>
          <li><a onClick={handleLogout(props)}>Logout</a></li>
        </>
        :
        <>
          <li><Link to='/login'>Login</Link></li>
          <li><Link to='/signup'>Sign Up</Link></li>
        </>
      }
    </ul>
  </nav>
)

export default withRouter(Nav)
